"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminArticleRemove } from "@/entities";
import { toast } from "react-toastify";
import { useParams, useRouter } from "next/navigation";

export function AdminArticleRemoveButton() {
  const router = useRouter();
  const params = useParams<{ slug: string; id: string }>();
  const slug = params?.slug || "";
  const id = params?.id || "";

  const queryClient = useQueryClient();

  const removeMutation = useMutation({
    mutationFn: adminArticleRemove,
    onSuccess: () => {
      toast.success("공지 정보가 삭제되었습니다.");
      queryClient.invalidateQueries({
        queryKey: [`admin-articles`, { slug, page: 1, perPage: 15 }],
      });
      router.push(`/admin/${slug}`);
    },
    onError: (e: any) => {
      toast.error(`에러(${e.message})가 발생했습니다. 다시 시도해 주세요.`);
    },
  });
  const onRemove = async () => {
    if (!confirm("정말 삭제하시겠습니까?")) return;
    if (removeMutation.isPending) return;
    await removeMutation.mutateAsync({ id });
  };

  return (
    <button
      type="button"
      className="btn btn-white text-danger"
      role="button"
      onClick={onRemove}
    >
      <i className="fa fa-trash"></i>
      <span> 삭제</span>
    </button>
  );
}
